export function newsDetails(bp, $) {
    let w = window.innerWidth;
    const news = {
        // ブログアイテム画像位置
        changeHtml(w) {
            const $newsItem = $('#js-entry-content').find('.block');
            $newsItem.each(function() {
                const $ele      = $(this).find('.wp-block-image');
                const $targetPC = $(this).find('.wp-block-group');
                const $targetSP = $(this).find('.block__ttl');
                //
                if(bp < w) {
                    $($ele).insertAfter($targetPC);
                } else {
                    $($ele).insertAfter($targetSP);
                }
            });
        }
    };


    news.changeHtml(w);
    $(window).resize(function() {
        w = window.innerWidth;
        news.changeHtml(w);
    });
}
